module.exports = __webpack_public_path__ + "img/prize2_active.4710968.png";